import type { OktaAuth } from "@okta/okta-auth-js";
import type { ReactNode } from "react";

import { Security } from "@okta/okta-react";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { oktaAuth } from "@/auth/oktaConfig";
import { AppRoute } from "@/types/routes";

interface SecurityProviderProps {
  readonly children: ReactNode;
}

/** Wraps the app in okta-react's <Security>, restoring the pre-login URL after the redirect callback. */
const SecurityProvider = ({ children }: SecurityProviderProps) => {
  const navigate = useNavigate();

  const restoreOriginalUri = useCallback(
    (_oktaAuth: OktaAuth, originalUri: string) => {
      void navigate(originalUri || AppRoute.Home, { replace: true });
    },
    [navigate]
  );

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      {children}
    </Security>
  );
};

export default SecurityProvider;
